
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { UblService } from "@/plugins/ubl/services/ubl-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			file: null as null | File,
			isSubmitting: false
		};
	},
	methods: {
		extendValidate(){
			if (!this.file) {
				this.isValid = false;
			}
		},
		async submit(){
			if (!this.isValid) return;
			if (this.isSubmitting) return;
			if (!this.file) return;
			let result = await UblService.purchaseFromUbl(this.file);
			this.$router.push(`/purchase/new?fromJson=${encodeURIComponent(JSON.stringify(result))}`);
			this.close();

		},
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
